/* eslint-disable no-nested-ternary */
/* eslint-disable radix */
/* eslint-disable no-continue */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-plusplus */
/* eslint-disable default-case */
/* eslint-disable no-param-reassign */
/* eslint-disable no-cond-assign */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
import CryptoJS from 'crypto-js';
import moment from 'moment';
import isAfter from 'date-fns/isAfter';
import isSameDay from 'date-fns/isSameDay';
import isBefore from 'date-fns/isBefore';
import add from 'date-fns/add';
import formatDistanceStrict from 'date-fns/formatDistanceStrict';
import {
  API_REQUEST_DATE_FORMAT_SLASH,
  DATE_MONTH_YEAR_TIME_FORMAT,
  TODAY_DATE,
} from '../constants/Constants';
import {
  getObjectFromLS,
  getUserAgentId,
  getValueFromAppConfig,
} from './localStorage';
import { APP_USER_PROFILE } from '../../saas/AppStorageStaticNames';

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
  });
};
export const scrollToBottom = () => {
  window.scrollTo({
    top: document.documentElement.scrollHeight,
    left: 0,
    behavior: 'smooth',
  });
};

export const isEmpty = (value) => {
  return (
    value === '' ||
    value === null ||
    value === undefined ||
    (typeof value === 'string' && value.trim() === '') ||
    (typeof value === 'number' && value.toString().trim() === '')
  );
};

export const formatDate = (date, dateFormat) => {
  try {
    if (date !== '' && date !== undefined && date !== null) {
      return moment(date, API_REQUEST_DATE_FORMAT_SLASH).format(dateFormat);
    }
    return '';
  } catch (error) {
    return '';
  }
};
export const getNewDate = (date) => {
  try {
    if (date === undefined || date === '' || date === null) {
      return '';
    }
    if (date === TODAY_DATE) {
      return new Date(moment().toDate());
    }
    return new Date(moment(date, API_REQUEST_DATE_FORMAT_SLASH).toDate());
  } catch (error) {
    return '';
  }
};

export const formatTimeStringWithoutMeridan = (time) => {
  try {
    time = time.toString();
    if (time.length < 4) {
      time = time.padStart(4, '0');
    }
    const hr = `${time}`.substring(0, 2);
    const min = `${time}`.substring(2);
    return `${hr}:${min}`;
  } catch (error) {
    return '';
  }
};

export const isAfterDate = (date, dateToCompare) => {
  return isAfter(date, dateToCompare);
};

export const isSameDate = (date, dateToCompare) => {
  return isSameDay(date, dateToCompare);
};

export const isBeforeDate = (date, dateToCompare) => {
  return isBefore(date, dateToCompare);
};

export const formatTimeString = (time) => {
  try {
    time = time.toString();
    if (time.indexOf(':') === -1) {
      if (time.length < 4) {
        time = time.padStart(4, '0');
      }
      const hr = `${time}`.substring(0, 2);
      const min = `${time}`.substring(2);
      // const meridian = parseInt(hr, 10) > 11 ? 'PM' : 'AM';
      return `${hr}:${min}`;
    }
    return time;
  } catch (error) {
    return '';
  }
};

export const formatTimeStringAmPmFormat = (time) => {
  try {
    time = time.toString();
    if (
      time.indexOf(':') === -1 &&
      time.indexOf('AM') === -1 &&
      time.indexOf('PM') === -1
    ) {
      if (time.length < 4) {
        time = time.padStart(4, '0');
      }
      const hr = `${time}`.substring(0, 2);
      const min = `${time}`.substring(2);
      let meridian = 'AM';
      let meridianHour = hr;
      if (parseInt(hr, 10) > 11) {
        meridian = 'PM';
        if (parseInt(hr, 10) > 12) {
          meridianHour = parseInt(hr, 10) - 12;
        }
      }
      if (hr === '00') {
        meridianHour = '12';
      }
      return `${meridianHour}:${min} ${meridian}`;
    }
    return time;
  } catch (error) {
    return '';
  }
};

export const convertTravelTime = (minutes) => {
  const tempMinutes = Math.abs(minutes);
  let hours = Math.floor(tempMinutes / 60);
  if (String(hours).length < 2) {
    hours = String(hours).padStart(2, '0');
  }
  let minute = Math.floor(tempMinutes % 60);
  if (String(minute).length < 2) {
    minute = String(minute).padStart(2, '0');
  }
  return `${hours}h ${minute}m`;
};
export const getCurrencySymbol = () => {
  return '₹';
};

export const getConnectingTime = (arrtime, arrdate, deptime, depdate) => {
  let tm = formatTimeString(arrtime).split(':');
  const at = add(getNewDate(arrdate), {
    hours: Number(tm[0]),
    minutes: Number(tm[1].split(' ')[0]),
  });

  tm = formatTimeString(deptime).split(':');
  const dt = add(getNewDate(depdate), {
    hours: Number(tm[0]),
    minutes: Number(tm[1].split(' ')[0]),
  });

  const duration = formatDistanceStrict(dt, at, { unit: 'minute' });
  return convertTravelTime(duration.split(' ')[0]);
};

export const formatCurrency = (val) => {
  try {
    if (!isEmpty(val)) {
      const valNumber = Number(val);
      const roundedValue = Math.round(valNumber);
      return new Intl.NumberFormat(
        `en-${getValueFromAppConfig('SAAS_APP_COUNTRY_CODE')}`,
        {
          style: 'currency',
          currency: getValueFromAppConfig('SAAS_APP_CURRENCY'),
          maximumFractionDigits: 0,
        },
      ).format(roundedValue);
    }
    return '';
  } catch (error) {
    return '';
  }
};
export const formatCurrencyWithoutSymbol = (val) => {
  try {
    if (!isEmpty(val)) {
      const valNumber = parseInt(val, 10);
      const roundedValue = Math.round(valNumber);
      const formattedNumber = new Intl.NumberFormat(
        `en-${getValueFromAppConfig('SAAS_APP_COUNTRY_CODE')}`,
        {
          maximumFractionDigits: 0,
        },
      ).format(roundedValue);
      return `${getValueFromAppConfig('SAAS_APP_CURRENCY')} ${formattedNumber}`;
    }
    return '';
  } catch (error) {
    return '';
  }
};

const getCarrierAndFlightNumber = (flightLeg) => {
  const carrier = flightLeg.carrier.substring(0, 2);
  const flightNumber = flightLeg.flightnumber;
  const flightDepDate = flightLeg.depdate;
  return `${carrier}@@@${flightNumber}@@@${flightDepDate}`;
};

const getFlightFare = (flightOption) => {
  let flightFare = flightOption.recommendedflight[0].flightfare;
  flightFare = Array.isArray(flightFare) ? flightFare : [flightFare];
  return flightFare.sort((fare1, fare2) => fare1.totalfq - fare2.totalfq);
};

const getAllFlightFares = (flightOption) => {
  let flightFare = flightOption.recommendedflight[0].flightfare;
  flightFare = Array.isArray(flightFare) ? flightFare : [flightFare];
  return flightFare.sort((fare1, fare2) => fare1.totalfq - fare2.totalfq);
};

export const getGroupedFlightOptions = (flightOptions) => {
  let groupedFlightOptions = [];
  if (flightOptions.length > 0) {
    groupedFlightOptions = flightOptions.reduce((acc, flightOption) => {
      let flightLegs = flightOption.recommendedflight[0].flightlegs;
      flightLegs = Array.isArray(flightLegs) ? flightLegs : [flightLegs];
      let carrierFlightNumber = '';
      flightLegs.forEach((leg) => {
        const carrierKey = getCarrierAndFlightNumber(leg);
        carrierFlightNumber += `${carrierKey}_`;
      });
      if (acc[carrierFlightNumber]) {
        const flightFare = getFlightFare(flightOption);
        let allFlightFares = getAllFlightFares(acc[carrierFlightNumber]);
        allFlightFares = [...allFlightFares, ...flightFare];
        allFlightFares.sort(
          (flightFare1, flightFare2) =>
            flightFare1.totalfq - flightFare2.totalfq,
        );
        acc[carrierFlightNumber].recommendedflight[0].flightfare =
          allFlightFares;
      } else {
        const flightFare = getFlightFare(flightOption);
        flightOption.recommendedflight[0].flightfare = flightFare;
        flightOption.recommendedflight[0].numstops = flightLegs.length - 1;
        acc[carrierFlightNumber] = flightOption;
      }
      return acc;
    }, []);
  }
  return groupedFlightOptions;
};

export const getInternationalGroupedFlights = (flightOptions) => {
  let groupedFlightOptions = [];
  if (flightOptions.length > 0) {
    groupedFlightOptions = flightOptions.reduce((acc, flightOption) => {
      let onwardFlightLegs = flightOption.recommendedflight[0].flightlegs;
      let returnFlightLegs = flightOption.recommendedflight[1].flightlegs;
      onwardFlightLegs = Array.isArray(onwardFlightLegs)
        ? onwardFlightLegs
        : [onwardFlightLegs];
      returnFlightLegs = Array.isArray(returnFlightLegs)
        ? returnFlightLegs
        : [returnFlightLegs];
      let onwardCarrierFlightNumber = '';
      let returnCarrierFlightNumber = '';
      onwardFlightLegs.forEach((leg) => {
        const carrierKey = getCarrierAndFlightNumber(leg);
        onwardCarrierFlightNumber += `${carrierKey}_`;
      });
      returnFlightLegs.forEach((leg) => {
        const carrierKey = getCarrierAndFlightNumber(leg);
        returnCarrierFlightNumber += `${carrierKey}_`;
      });
      const carrierFlightNumber = `${onwardCarrierFlightNumber}#${returnCarrierFlightNumber}`;
      if (acc[carrierFlightNumber]) {
        const flightFare = getFlightFare(flightOption);
        let allFlightFares = getAllFlightFares(acc[carrierFlightNumber]);
        allFlightFares = [...allFlightFares, ...flightFare];
        allFlightFares.sort(
          (flightFare1, flightFare2) =>
            flightFare1.totalfq - flightFare2.totalfq,
        );
        acc[carrierFlightNumber].recommendedflight[0].flightfare =
          allFlightFares;
      } else {
        const flightFare = getFlightFare(flightOption);
        flightOption.recommendedflight[0].flightfare = flightFare;
        acc[carrierFlightNumber] = flightOption;
      }
      return acc;
    }, []);
  }
  return groupedFlightOptions;
};

export const getInternationalMulitCityGroupedFlights = (flightOptions) => {
  let groupedFlightOptions = [];
  if (flightOptions.length > 0) {
    groupedFlightOptions = flightOptions.reduce((acc, flightOption) => {
      let carrierFlightNumber = '';
      flightOption.recommendedflight.forEach((flt) => {
        let legs = flt.flightlegs;
        legs = Array.isArray(legs) ? legs : [legs];
        let carrierFlightNumberForFlt = '';
        legs.forEach((leg) => {
          const carrierKey = getCarrierAndFlightNumber(leg);
          carrierFlightNumberForFlt += `${carrierKey}_`;
        });
        carrierFlightNumber += `${carrierFlightNumberForFlt}#`;
      });
      if (acc[carrierFlightNumber]) {
        const flightFare = getFlightFare(flightOption);
        let allFlightFares = getAllFlightFares(acc[carrierFlightNumber]);
        allFlightFares = [...allFlightFares, ...flightFare];
        allFlightFares.sort(
          (flightFare1, flightFare2) =>
            flightFare1.totalfq - flightFare2.totalfq,
        );
        acc[carrierFlightNumber].recommendedflight[0].flightfare =
          allFlightFares;
      } else {
        const flightFare = getFlightFare(flightOption);
        flightOption.recommendedflight[0].flightfare = flightFare;
        acc[carrierFlightNumber] = flightOption;
      }
      return acc;
    }, []);
  }
  return groupedFlightOptions;
};

export default {
  formatDate,
  isAfterDate,
  formatTimeString,
  convertTravelTime,
  getGroupedFlightOptions,
  getInternationalGroupedFlights,
  getInternationalMulitCityGroupedFlights,
};

export const formatBookingDate = (dateTime) => {
  try {
    if (dateTime === undefined)
      return formatDate(getNewDate(TODAY_DATE), DATE_MONTH_YEAR_TIME_FORMAT);
    return moment(dateTime, 'YYYY-MM-DD HH:mm:ss.S').format(
      'DD, MMM YYYY h:mm A',
    );
  } catch (error) {
    return '';
  }
};

// export const serialize = (obj, prefix) => {
//   const str = [];
//   let p;
//   for (p in obj) {
//     if (obj.hasOwnProperty(p)) {
//       const k = prefix ? `${prefix}[${p}]` : p;
//       const v = obj[p];
//       str.push(
//         v !== null && typeof v === 'object'
//           ? serialize(v, k)
//           : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`,
//       );
//     }
//   }
//   return str.join('&');
// };

// export const serialize = (obj, prefix) => {
//   const str = [];
//   let p;
//   for (p in obj) {
//     if (obj.hasOwnProperty(p)) {
//       const k = prefix ? `${prefix}[${p}]` : p;
//       const v = obj[p];

//       if (k === 'destinationType') {
//         let val;
//         try {
//           val = v.replace(/[\[\]\s]/g, '').split(',');
//         } catch {
//           val = v;
//         }

//         str.push(
//           `${encodeURIComponent(k)}=[${val
//             .map((value) => encodeURIComponent(value))
//             .join(',')}]`,
//         );
//         // str.push(`${encodeURIComponent(k)}=${v}`);
//       } else {
//         str.push(
//           v !== null && typeof v === 'object'
//             ? serialize(v, k)
//             : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`,
//         );
//       }
//     }
//   }
//   return str.join('&');
// };

export const serialize = (obj, prefix) => {
  const str = [];

  for (const p in obj) {
    if (!obj.hasOwnProperty(p)) continue;

    const k = prefix ? `${prefix}[${p}]` : p;
    const v = obj[p];

    if (k === 'destinationType') {
      let val;
      try {
        val = v.replace(/[\[\]\s]/g, '').split(',');
      } catch {
        val = v;
      }

      str.push(
        `${encodeURIComponent(k)}=[${val
          .map((value) => encodeURIComponent(value))
          .join(',')}]`,
      );
    } else if (Array.isArray(v)) {
      if (v.length === 0) {
        // ✅ empty array
        str.push(`${encodeURIComponent(k)}[]`);
      } else {
        v.forEach((val, idx) => {
          if (typeof val === 'object' && val !== null) {
            // array of objects
            str.push(serialize(val, `${k}[${idx}]`));
          } else {
            // array of primitives
            str.push(
              `${encodeURIComponent(k)}[${idx}]=${encodeURIComponent(val)}`,
            );
          }
        });
      }
    } else if (v !== null && typeof v === 'object') {
      str.push(serialize(v, k));
    } else {
      str.push(`${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
    }
  }

  return str.join('&');
};

export const parseDate = (selectedDate) => {
  const dateSplit = selectedDate.split('-');
  const year = dateSplit[2];
  const month = dateSplit[1];
  const date = dateSplit[0];
  return `${year}-${month.padStart(2, 0)}-${date.padStart(2, 0)}`;
};

export const getDateWithHypends = (selectedDate) => {
  const year = selectedDate.substring(0, 4);
  const month = selectedDate.substring(4, 6);
  const date = selectedDate.substring(6, 8);
  return `${year}-${month.padStart(2, 0)}-${date.padStart(2, 0)}`;
};

export const getTrainDaysOfRun = (trainDetails) => {
  let result = '';
  if (trainDetails.runningSun === 'Y') {
    result += 'SUN, ';
  }
  if (trainDetails.runningMon === 'Y') {
    result += 'MON, ';
  }
  if (trainDetails.runningTue === 'Y') {
    result += 'TUE, ';
  }
  if (trainDetails.runningWed === 'Y') {
    result += 'WED, ';
  }
  if (trainDetails.runningThu === 'Y') {
    result += 'THU, ';
  }
  if (trainDetails.runningFri === 'Y') {
    result += 'FRI, ';
  }
  if (trainDetails.runningSat === 'Y') {
    result += 'SAT, ';
  }
  result = result.substring(0, result.length - 2);
  return result;
};

export const getTrainDaysOfRunWithDash = (trainDetails) => {
  let result = '';

  if (trainDetails.runningMon === 'Y') {
    result += 'M, ';
  } else if (trainDetails.runningMon === 'N') {
    result += '- ';
  }
  if (trainDetails.runningTue === 'Y') {
    result += 'Tu, ';
  } else if (trainDetails.runningTue === 'N') {
    result += '- ';
  }
  if (trainDetails.runningWed === 'Y') {
    result += 'W, ';
  } else if (trainDetails.runningWed === 'N') {
    result += '- ';
  }
  if (trainDetails.runningThu === 'Y') {
    result += 'Th, ';
  } else if (trainDetails.runningThu === 'N') {
    result += '- ';
  }
  if (trainDetails.runningFri === 'Y') {
    result += 'F, ';
  } else if (trainDetails.runningFri === 'N') {
    result += '- ';
  }
  if (trainDetails.runningSat === 'Y') {
    result += 'Sa, ';
  } else if (trainDetails.runningSat === 'N') {
    result += '- ';
  }
  if (trainDetails.runningSun === 'Y') {
    result += 'S, ';
  } else if (trainDetails.runningSun === 'N') {
    result += '- ';
  }
  result = result.substring(0, result.length - 2);
  return result;
};

export const getTrainDaysOfRunAlt = (trainDetails) => {
  let result = '';
  if (trainDetails.trainRunsOnMon === 'Y') {
    result += 'M, ';
  }
  if (trainDetails.trainRunsOnTue === 'Y') {
    result += 'Tu, ';
  }
  if (trainDetails.trainRunsOnWed === 'Y') {
    result += 'W, ';
  }
  if (trainDetails.trainRunsOnThu === 'Y') {
    result += 'Th, ';
  }
  if (trainDetails.trainRunsOnFri === 'Y') {
    result += 'F, ';
  }
  if (trainDetails.trainRunsOnSat === 'Y') {
    result += 'Sa, ';
  }
  if (trainDetails.trainRunsOnSun === 'Y') {
    result += 'S, ';
  }
  result = result.substring(0, result.length - 2);
  return result;
};

export const getBookingClassText = (c) => {
  switch (c) {
    case 'W':
      return 'Business';
    case 'C':
      return '';
  }
  return 'Economy';
};

export const hideHeaderMenu = () => {
  document.getElementsByClassName('app-header')[0].style.display = 'none';
  document.getElementsByClassName('app-main-content')[0].style.marginTop = '0';
};

export const hideHeaderOptions = () => {
  document.getElementsByClassName('app-header-options')[0].style.display =
    'none';
};

export const showHeaderOptions = () => {
  document.getElementsByClassName('app-header-options')[0].style.display =
    'block';
};

export const showHeaderMenu = () => {
  document.getElementsByClassName('app-header')[0].style.display = 'block';
  document.getElementsByClassName('app-main-content')[0].style.marginTop =
    '70px';
};
export const hideHeaderFooter = () => {
  document.getElementsByClassName('app-header')[0].style.display = 'none';
  document.getElementsByClassName('app-footer')[0].style.display = 'none';
  document.getElementsByClassName('app-main-content')[0].style.marginTop = '0';
};

export const showHeaderFooter = () => {
  document.getElementsByClassName('app-header')[0].style.display = 'block';
  document.getElementsByClassName('app-footer')[0].style.display = 'block';
  document.getElementsByClassName('app-main-content')[0].style.marginTop =
    '70px';
};

export const showUpdatesOptions = () => {
  document.getElementsByClassName('app-header-updates')[0].style.display =
    'block';
};
export const hideUpdatesOptions = () => {
  document.getElementsByClassName('app-header-updates')[0].style.display =
    'none';
};
export const alignLogoInBookingPage = () => {
  document.getElementsByClassName('app-header-logo')[0].style.position =
    'absolute';
  document.getElementsByClassName('app-header-logo')[0].style.top = '22px';
  document.getElementsByClassName('app-header-logo')[0].style.zIndex = '12';
};
export const removeAlignLogoINBookingPgae = () => {
  document.getElementsByClassName('app-header-logo')[0].style.position =
    'static';
};

export const hideHeaderFooterInMobile = () => {
  if (window.innerWidth < 599) {
    if (!isEmpty(document.getElementsByClassName('app-header'))) {
      document.getElementsByClassName('app-header')[0].style.display = 'none';
      document.getElementsByClassName('app-main-content')[0].style.marginTop =
        '0px';
    }
    if (!isEmpty(document.getElementsByClassName('app-footer'))) {
      document.getElementsByClassName('app-footer')[0].style.display = 'none';
    }
  }
};
export const showHeaderFooterInMobile = () => {
  if (window.innerWidth < 599) {
    if (!isEmpty(document.getElementsByClassName('app-header'))) {
      document.getElementsByClassName('app-header')[0].style.display = 'block';
      document.getElementsByClassName('app-main-content')[0].style.marginTop =
        '0px';
    }
    if (!isEmpty(document.getElementsByClassName('app-footer'))) {
      document.getElementsByClassName('app-footer')[0].style.display = 'block';
    }
  }
};

export const getFlightNumberForAgent = (carrier, fltNumber) => {
  if (
    carrier !== '' &&
    carrier !== null &&
    carrier !== undefined &&
    fltNumber !== '' &&
    fltNumber !== null &&
    fltNumber !== undefined
  ) {
    return `${carrier.substring(0, 2)}-${fltNumber}`;
  }
  return '';
};

export const isMobileWidth = () => {
  return window.innerWidth < 599;
};

export const getTerminalNumberwithTerminal = (terminal) => {
  if (
    terminal !== undefined &&
    terminal !== null &&
    terminal !== '' &&
    terminal !== '-' &&
    terminal !== 'null'
  ) {
    const terNumber = terminal
      .toLowerCase()
      .replace('terminal', '')
      .replace('t', '');
    return `Terminal-${terNumber}`;
  }
  return '';
};
export const getTerminalNumber = (terminal) => {
  if (
    terminal !== undefined &&
    terminal !== null &&
    terminal !== '' &&
    terminal !== '-' &&
    terminal !== 'null'
  ) {
    const terNumber = terminal
      .toLowerCase()
      .replace('terminal', '')
      .replace('t', '');
    return `- T${terNumber}`;
  }
  return '';
};
export const getOnlyTerminalNumber = (terminal) => {
  if (
    terminal !== undefined &&
    terminal !== null &&
    terminal !== '' &&
    terminal !== '-' &&
    terminal !== 'null'
  ) {
    const terNumber = terminal
      .toLowerCase()
      .replace('terminal', '')
      .replace('t', '');
    return `${terNumber}`;
  }
  return '';
};

export const getCabinBaggage = (weight, unit) => {
  if (
    weight !== '' &&
    unit !== '' &&
    weight !== undefined &&
    unit !== undefined &&
    weight !== null &&
    unit !== null
  ) {
    const adtW =
      weight.split('-')[0]?.split('@')[1] === undefined
        ? ''
        : weight.split('-')[0]?.split('@')[1];
    const adtU =
      unit.split('-')[0]?.split('@')[1] === undefined
        ? ''
        : unit.split('-')[0]?.split('@')[1];
    return `${adtW}${adtU}`;
  }
  return '';
};

export const getBaggage = (weight, unit) => {
  if (
    weight !== '' &&
    weight !== undefined &&
    weight !== null &&
    unit !== '' &&
    unit !== undefined &&
    unit !== null
  ) {
    const adtW =
      weight.split('-')[0]?.split('@')[1] === undefined
        ? ''
        : weight.split('-')[0]?.split('@')[1];
    const chdW =
      weight.split('-')[1]?.split('@')[1] === undefined
        ? ''
        : weight.split('-')[1]?.split('@')[1];
    const adtU =
      unit.split('-')[0]?.split('@')[1] === undefined
        ? ''
        : unit.split('-')[0]?.split('@')[1];
    const chdU =
      unit.split('-')[1]?.split('@')[1] === undefined
        ? ''
        : unit.split('-')[1]?.split('@')[1];
    return `ADT-${adtW}${adtU} ${chdW ? `CHD-${chdW}${chdU}` : ''}`;
  }
  return 'No Baggage Found';
};

export const failedResponseForFareRules = () => {
  return '<div style="font-size: 14px"> <span style="display: block; ">Fare rules for this fare are not available at the moment. Please contact our customer support team.</span> </div>';
};

export const getTerminalNumberwithT = (terminal) => {
  if (
    terminal !== undefined &&
    terminal !== null &&
    terminal !== '' &&
    terminal !== '-' &&
    terminal !== 'null'
  ) {
    const terNumber = terminal
      .toLowerCase()
      .replace('terminal', '')
      .replace('t', '');
    return `- T${terNumber}`;
  }
  return '';
};

export const getSupplierName = (supplier) => {
  try {
    const userProfile = getObjectFromLS(APP_USER_PROFILE);
    const agentRole = userProfile.systemRoleId;
    const agentIds = getValueFromAppConfig('SAAS_SHOW_SUPPLEIR');
    const hasAgentId = agentIds?.split(',')?.indexOf(getUserAgentId()) > -1;
    if (
      agentRole === '1' ||
      agentRole === '2' ||
      agentRole === 1 ||
      agentRole === 2 ||
      hasAgentId
    ) {
      return supplier;
    }
    return '';
  } catch (error) {
    return '';
  }
};
export const showSupplier = () => {
  try {
    const userProfile = getObjectFromLS(APP_USER_PROFILE);
    const agentRole = userProfile.systemRoleId;
    const agentIds = getValueFromAppConfig('SAAS_SHOW_SUPPLEIR');
    const hasAgentId = agentIds?.split(',')?.indexOf(getUserAgentId()) > -1;
    if (
      agentRole === '1' ||
      agentRole === '2' ||
      agentRole === 1 ||
      agentRole === 2 ||
      hasAgentId
    ) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};
export const isAdminOrAdminStaff = () => {
  const userProfile = getObjectFromLS(APP_USER_PROFILE);
  const agentRole = userProfile.systemRoleId;
  if (
    agentRole === '1' ||
    agentRole === '2' ||
    agentRole === 1 ||
    agentRole === 2
  ) {
    return true;
  }
  return false;
};

export const getEligibilityForPaymentMode = (paymentMode) => {
  return true;
};

export const getEligibilityForPgOptions = () => {
  return true;
  // if (
  //   getEligibilityForPaymentMode('creditcard') ||
  //   getEligibilityForPaymentMode('debitcard') ||
  //   getEligibilityForPaymentMode('upi') ||
  //   getEligibilityForPaymentMode('netbanking')
  // ) {
  //   return true;
  // }
  // return false;
};

export const getNumSeats = (seats) => {
  const numSeats = parseInt(seats, 10);
  if (numSeats < 9) {
    return numSeats;
  }
  return 9;
};

export const getResponseFromEncyptedText = (response) => {
  try {
    const responseStr = response.response.split('**********');
    const textToBeUsed = CryptoJS.enc.Base64.parse(responseStr[0]);
    const textToBeConverted = CryptoJS.enc.Base64.parse(responseStr[1]);
    const actualText = CryptoJS.lib.CipherParams.create({
      ciphertext: textToBeConverted,
      formatter: CryptoJS.format.OpenSSL,
    });
    const actualResponse = CryptoJS.AES.decrypt(actualText, textToBeUsed, {
      keySize: 32,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    const actualResponseJsonString = actualResponse.toString(CryptoJS.enc.Utf8);
    return JSON.parse(actualResponseJsonString);
  } catch (e) {
    return undefined;
  }
};

export const hasStopOverInfo = (stopover) => {
  const hasStopOver =
    !isEmpty(stopover) &&
    stopover.trim() !== '' &&
    stopover !== 'N' &&
    stopover !== '0' &&
    stopover !== 0 &&
    stopover !== '-';
  return hasStopOver;
};

export const getCancellationPolicyFormat = (policies) => {
  return (
    <div className="overflow-x-auto">
      <table className="table-auto w-full border-collapse border border-gray-300">
        <thead className="bg-body-secondary">
          <tr>
            <th className="border p-2">Cancellation on or After</th>
            <th className="border p-2">Cancellation on or Before</th>
            <th className="border p-2">Cancellation Charges</th>
          </tr>
        </thead>
        <tbody>
          {policies.length > 0 ? (
            policies.map((policy, index) => (
              <tr key={index} className="text-center">
                <td className="border p-2">
                  {' '}
                  {policy.fromDateTime
                    ? policy.fromDateTime.replace('T', ' ')
                    : ''}
                </td>
                <td className="border p-2">
                  {policy.toDateTime ? policy.toDateTime.replace('T', ' ') : ''}
                </td>
                <td className="border p-2">
                  {policy.penaltyValue} ({policy.penaltyType})
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="border p-2 text-center">
                No Cancellation Policies Available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export const getTime24Hour = (dateString) => {
  // const date = new Date(dateString);
  // return date.toTimeString().split(' ')[0]; // Returns "HH:MM:SS"
  const date = new Date(dateString);
  const [hours, minutes] = date.toTimeString().split(':');
  return `${hours}:${minutes}`;
};

export const parseTimeString = (timeStr) => {
  if (!timeStr) return null;
  const [hours, minutes] = timeStr.split(':');
  const date = new Date();
  date.setHours(parseInt(hours), parseInt(minutes), 0, 0);
  return date;
};

export const getFlightNumbers = (
  flt,
  userSelectedFare,
  isReturn,
  isMultiCity,
) => {
  try {
    const flightnumbers = [];
    flt.flightlegs.forEach((leg, lgindex) => {
      let flightNumber;
      if (isMultiCity) {
        flightNumber = getFlightNumberForAgent(
          userSelectedFare.flightCarrier[lgindex][0],
          leg.flightnumber,
        );
      } else if (isReturn) {
        flightNumber = getFlightNumberForAgent(
          userSelectedFare.flightCarrierReturn[lgindex],
          leg.flightnumber,
        );
      } else {
        flightNumber = getFlightNumberForAgent(
          userSelectedFare.flightCarrier[lgindex],
          leg.flightnumber,
        );
      }
      flightnumbers.push(flightNumber);
    });
    const uniqueFltNumbers = Array.from(new Set(flightnumbers));
    const uniqueFltNumbersString = uniqueFltNumbers.join(', ');
    return uniqueFltNumbersString;
  } catch (error) {
    return '';
  }
};

export const getEquipment = (flt, userSelectedFare, isReturn, isMultiCity) => {
  try {
    const flightEquipment = [];
    flt.flightlegs.forEach((leg, lgindex) => {
      flightEquipment.push(
        `${
          isMultiCity
            ? userSelectedFare.flightEquipment[lgindex][0]
            : isReturn
            ? userSelectedFare.flightEquipmentReturn[lgindex]
            : userSelectedFare.flightEquipment[lgindex]
        }`,
      );
    });
    const uniqueFltNumbers = Array.from(new Set(flightEquipment));
    const uniqueFltNumbersString = uniqueFltNumbers.join(', ');
    return uniqueFltNumbersString;
  } catch (error) {
    return '';
  }
};

export const getOperatedBy = (flt, userSelectedFare, isReturn, isMultiCity) => {
  try {
    const flightOperatedBy = [];
    flt.flightlegs.forEach((leg, lgindex) => {
      flightOperatedBy.push(
        `${
          isMultiCity
            ? userSelectedFare.flightOperatedBy[lgindex][0]
            : isReturn
            ? userSelectedFare.flightOperatedByReturn[lgindex]
            : userSelectedFare.flightOperatedBy[lgindex]
        }`,
      );
    });
    const uniqueFltNumbers = Array.from(new Set(flightOperatedBy));
    const uniqueFltNumbersString = uniqueFltNumbers.join(', ');
    return uniqueFltNumbersString;
  } catch (error) {
    return '';
  }
};
